import React from "react";
import UpcomingCheckIns from "../../../features/trips/pages/upcomingCheckIns";

export default function UpcomingCheckInsPage() {
  return <UpcomingCheckIns />;
}
